import type { TranslationKey } from "../locales";
import { formatNumber } from "../numbers";
import { getUnitTranslationKey, guardString } from "../strings";
import type { Nullable, Tables } from "../types";

/**
 * This function formats the numeric value of a partner agreement based on its type to present it in a user-friendly way.
 * @param agreement
 * @returns
 */
export function formatNumericPartnerAgreementValue(
	agreement: Nullable<Tables<"organizationPartnershipAgreements">>,
	_localizer?: (key: TranslationKey | null) => string,
): string {
	if (!agreement) return guardString(null);

	const localizer = _localizer || ((key: string | null) => key);

	switch (agreement.type) {
		case "hourly-rate":
			return formatNumber(agreement.value, "currency");
		case "payment-target":
			return `${agreement.value} ${localizer(getUnitTranslationKey(agreement.unit))}`;
		case "early-payment-discount":
			return `${agreement.value} %`;
		case "early-payment-discount-payment-target":
			return `${agreement.value} ${localizer(getUnitTranslationKey(agreement.unit))}`;
		default:
			return `${agreement.value}`;
	}
}
